import React from 'react'
import BookForm from '../form/BookForm';
import { useGetBookQuery } from "../../features/api/apiSlice";
import { useParams } from "react-router-dom";

function EditBook() {
    //variables
    const { bookId } = useParams();
    const { data: book } = useGetBookQuery(bookId);

    //JSX
    return (
        <div className="p-8 overflow-hidden bg-white shadow-cardShadow rounded-md max-w-xl mx-auto">
            <h4 className="mb-8 text-xl font-bold text-center">Edit Book</h4>
            <BookForm book={book} />
        </div>
    )
}

export default EditBook